<template>
    <div>
        <v-card-text>
            <v-row>
                <v-col> </v-col>

                <v-col cols="2">
                    <v-btn color="green" dark @click="limpiarFiltros">
                        Limpiar Filtros
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>

        <v-data-table
            :headers="cabeceras_usuarios"
            :items="usuarios_filtrados"
            :items-per-page="20"
            item-class="filita"
            class="elevation-2 mt-1"
            dense
        >
            <template v-slot:header="{ item }">
                <tr>
                    <th v-for="cab in cabeceras_usuarios" class="filita px-2">
                        <v-text-field
                            v-if="cab.value === 'name'"
                            label="Buscar por nombre"
                            v-model="filtros.name"
                        ></v-text-field>
                    </th>
                </tr>
            </template>
            <template v-slot:item.icono="{ item }">
                <span
                    ><v-icon>{{ item.icono }}</v-icon></span
                >
            </template>
            <template v-slot:item.roles="{ item }">
                <v-select
                    v-model="item.roles"
                    :items="item.roles"
                    item-text="name"
                    item-value="id"
                    label="Roles"
                    multiple
                    readonly
                    small-chips
                ></v-select>
            </template>
            <template v-slot:item.acciones="{ item }">
                <v-icon @click="abrirModal(item)" color="blue" class="mx-2" title="Modificar roles de usuario" v-if="can_manipulate">edit</v-icon>
                <v-icon color="warning" title="No tienes permitido realizar estas acciones" v-else>info</v-icon>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';

export default {
    data: () => ({
        usuarios: [],
        cabeceras_usuarios: [
            { text: 'Nombre',   align: 'center',    sortable: true,     value: 'name',     class: 'cabecera',},
            { text: 'Usuario (RUT)',      align: 'center',    sortable: true,     value: 'user',   class: 'cabecera',},
            { text: 'E-mail',         align: 'center',    sortable: true,     value: 'email',      class: 'cabecera',},
            { text: 'Rol de Usuario',        align: 'center',    sortable: true,     value: 'roles',     class: 'cabecera',},
            { text: 'Acción', align: 'center', sortable: true, value: 'acciones', class: 'cabecera' }
        ],
        filtros: {
            name: "",
        },
    }),
    props: {
        roles: Array,
        can_manipulate: Boolean,
    },
    mounted() {
        this.cargarUsuarios();
    },
    methods: {
        async cargarUsuarios() {
            this.mostrarLoading({ titulo: "Cargando usuarios...", color: "green" })
            const url = `${this.base_url}user`;
            await this.axios.get(url, this.headers).then(res => {
                console.log({usuarios: res.data.data});
                this.usuarios = res.data.data;
                this.ocultarLoading();
            }).catch(error => {
                console.error('error',error);
                this.errorMessage(error, "Error al cargar menús");
            });
        },
        abrirModal(item) {
            this.$emit('abrir_modal_user_roles', [this.roles, item]);
        },
        limpiarFiltros() {
            for (const key in this.filtros) {
                this.filtros[key] = "";
            }
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        usuarios_filtrados() {
            return this.usuarios.filter(usuario => {
                let filtrado = true;
                if(this.filtros.name) {
                    filtrado = usuario.name.toLowerCase().includes(this.filtros.name.toLowerCase());
                    if(!filtrado) return false;
                } 
                return filtrado;
            });
        },
        ...mapState(['base_url','headers']),
    }
};
</script>

<style scoped>
</style>
